export default __webpack_public_path__ + "static/media/backgroundMusic.41c0df77.mp3";